import { ACTIONS } from "UTILS/Constants";

const initialState = {
  logoUrl: null,
  wordingUrl: "",
  isWordingFetched: false,
  customerData:{},
  currentActiveTab:"1",
  sessionKey: null,
  Organization:null,
  sessionsCapacity: {
    systemMaxCapacity: 0,
    usedCapacity: 0
  },
  cobrowseSettings: {
    cobrowseType: "",
    allowCustomUrl: false,
    customUrlLabels: [], 
    targetSites: [],
  },
  operatorSkills: [],
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ACTIONS.SET_ADMIN_LOGO_URL:
      return {
        ...state,
        logoUrl: action.logoUrl
      };
    case ACTIONS.SET_WORDING_URL:
      return {
        ...state,
        wordingUrl: action.wordingUrl
      }
    case ACTIONS.SET_IS_WORDING_FETCHED:
      return {
        ...state,
        isWordingFetched: action.isWordingFetched
      }
    case ACTIONS.SET_CUSTOMER_DATA:
      return {
        ...state,
        customerData: action.customerData
      };
    case ACTIONS.ORGANISATION_ACTION.SET_ACTIVE_TAB:
      return{
        ...state,
        currentActiveTab:action.value
      };
    case ACTIONS.ORGANISATION_ACTION.SET_ORGANIZATION_DATA:
      return{
        ...state,
        Organization:action.organization
      };
    case ACTIONS.SET_SESSIONS_CAPACITY:
      return{
        ...state,
        sessionsCapacity:action.sessionsCapacity
      };
    case ACTIONS.CO_BROWSE.SET_CO_BROWSE_DETAILS:
      return{
        ...state,
        cobrowseSettings: action.cobrowseSettings
      };
    case ACTIONS.SUPPORT_CENTER.SET_SKILL_LIST:
      return{
        ...state,
        operatorSkills: action.operatorSkills
      };
    default:
      return state;
  }}